const ChevronDown = ({ width = 24, height = 24, customClass = '' }) => (
  <svg aria-hidden='true' width={width} height={height} class={customClass} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z' fill='currentColor' />
  </svg>
)

export default ChevronDown
